import { useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { useNavigate } from 'react-router-dom';
import ScriptSureIframeLayout from '../../components/ScriptSure/ScriptSureIframeLayout';

const PatientPrescriptions = () => {
    const navigate = useNavigate();
    const [getHelpModalOpen, setGetHelpModalOpen] = useState<boolean>(false);

    return (
        <div>
            <PageTitle title="Prescriptions" onClick={() => navigate(-1)}>
                <div className="get-help">
                    <button
                        type="button"
                        style={{ backgroundColor: 'rgb(33,150,243)' }}
                        className="btn btn-primary btn-sm"
                        onClick={() => setGetHelpModalOpen(true)}
                    >
                        Get Help
                    </button>
                </div>
            </PageTitle>
            <ScriptSureIframeLayout
                scriptSureSource={(
                    webAppUrl: string,
                    scriptSurePatientId: number,
                    scriptSureSessionToken: string,
                ) =>
                    `${webAppUrl}/chart/${scriptSurePatientId}/prescriptions?sessiontoken=${scriptSureSessionToken}&darkmode=off`
                }
                getHelpModalOpen={getHelpModalOpen}
                setGetHelpModalOpen={setGetHelpModalOpen}
            />
        </div>
    );
};

export default PatientPrescriptions;
